<template lang="html">
  <div>
    <b-modal modal-class="modal-cv-templ" ref="modal-cv-experience" size="lg" title="Experiencia Laboral" @hidden="hiddenModal()" no-close-on-esc no-close-on-backdrop centered hide-footer>

      <b-form class="px-2" @submit="onSubmit" v-if="showForm">
        <div class="row align-items-center">
          <b-form-group class="col-lg-5 custom-f-group-1 txt-sm" label="Empresa:">
            <b-form-input
              v-model="formExp.empresa"
              type="text"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <div class="col-sm-9 col-lg-5">
            <div class="row">
              <b-form-group class="col-6 px-lg-1 custom-f-group-1 txt-sm" label="Desde:">
                <b-form-select required v-model="formExp.desde">
                  <b-form-select-option :value="null">Año</b-form-select-option>
                  <b-form-select-option :value="yd" v-for="(yd, ydesInx) in years" :key="'ydesInx-'+ydesInx">{{ yd }}</b-form-select-option>
                </b-form-select>
              </b-form-group>

              <b-form-group class="col-6 px-sm-0 px-lg-1 custom-f-group-1 txt-sm" label="Hasta:" v-if="formExp.actual == 0">
                <b-form-select required v-model="formExp.hasta">
                  <b-form-select-option :value="null">Año</b-form-select-option>
                  <b-form-select-option :value="yh" v-for="(yh, yhasInx) in years" :key="'yhasInx-'+yhasInx">{{ yh }}</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="col-sm-3 col-lg-2 mt-sm-2">
            <b-form-checkbox
              id="checkbox-1"
              v-model="formExp.actual"
              name="checkbox-1"
              :value="1"
              :unchecked-value="0">
              Actual
            </b-form-checkbox>
          </div>

          <b-form-group class="col-lg-12 custom-f-group-1 txt-sm" label="Puesto:">
            <b-form-input
              v-model="formExp.puesto"
              type="text"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="col-lg-12 custom-f-group-1 txt-sm" label="Descripción adicional:">
            <b-form-input
              v-model="formExp.descripcion"
              type="text"
              placeholder=""
              required
            ></b-form-input>
          </b-form-group>

          <div class="col-12 mt-2">
            <b-form-checkbox
              required
              class="mb-3 custom-checkbox-s1"
              v-model="formExp.check"
              name="checkbox-1"
              value="accepted"
              :unchecked-value="null">
              Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
            </b-form-checkbox>

            <b-button type="submit" v-if="!editing" class="btn-HelvNeu btn-squ-cur-1 px-4 btn-send">Agregar</b-button>
            <b-button type="submit" v-else class="btn-HelvNeu btn-squ-cur-1 px-4 btn-send">Editar</b-button>
          </div>

        </div>
      </b-form>

    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    id: {
      default: null
    }
  },

  data(){
    return{
      showForm: false,
      years: [],

      formExp: {
        cvdescription: null,
        check: null,
        actual:0
      }
    }
  },

  methods: {
    hiddenModal(){
      this.$parent.selectedModalCV = null;
      this.$parent.editing = false;
      this.$parent.expID = null;
    },

    onSubmit(event) {
      event.preventDefault();

        axios.post(tools.url("/api/admin/updateCvExperiencia"),this.formExp).then((response)=>{
            this.$root.auth();
            this.savedmsg = 'Información guardada correctamente';
            this.$refs['modal-cv-experience'].hide(); // Ocultar modal despues de guardar

            
        }).catch((error)=>{
            alert('Ocurrio un error al guardar la información');

        });

    },
  },

  mounted(){
    let maxYears = 74;
    let firstYear = ( (new Date().getFullYear()) - maxYears );
    for (var i = 0; i <= maxYears; i++) {
      this.years.unshift(firstYear + i);
    }

    if(this.editing){
      this.formExp = this.$root.user.cv.experiences[this.$parent.expID];
      //console.log('Consultar la info de la BD para agregarla al "formExp"');
    }

    this.$refs['modal-cv-experience'].show();

    setTimeout( ()=>{ this.showForm = true; }, 500);
  },
}
</script>
